export class UpdateTipoSelladoRequest {
    
    public id : number=0;
    public descripcion : string="";
    public valor : number=0;
}